import React from 'react'
const Error = () => {
  return (
    <div className='w-screen h-screen text-4xl flex items-center justify-center text-richblack-5'>ERROR-404</div>
  )
}
export default Error;
